<div class="event-after-dialog">
  <div class="dialog-body">
    <div class="dialog-content">
      <div class="left-content">
        <div
          class="event-card"
          [class.withdraw-answer]="rsvpType === RSVPOptionType.NO"
        >
          <div class="event-card-header">
            <div>
              @if (rsvpType === RSVPOptionType.NO) {
                {{
                  "APP.EVENT_AFTER_ATTEND.GENERIC.ANSWER_WITHDRAWN" | translate
                }}
              } @else {
                {{ "APP.EVENT_AFTER_ATTEND.GENERIC.SUCCESS" | translate }}
              }
            </div>
            <div class="close-button-custom">
              <i class="far fa-times icon-regular" (click)="close()"></i>
            </div>
          </div>
          <div class="page-content">
            <div
              class="page-title"
              [innerHTML]="
                getTitle(EventRSVPConfirmationPageSectionType.MAIN) | safeHtml
              "
            ></div>
            <div
              class="page-description"
              [innerHTML]="
                getDescription(EventRSVPConfirmationPageSectionType.MAIN)
                  | safeHtml
              "
            ></div>
          </div>
          <div class="event-info">
            <div
              class="event-info-content"
              [class.withdraw-answer]="rsvpType === RSVPOptionType.NO"
            >
              <div class="event-image">
                <img
                  [src]="encodedMainImage()"
                  class="key-visual-img"
                  alt="Key Visual"
                />
              </div>
              <div class="event-right-content">
                <div class="event-description">
                  <div class="event-name">
                    {{ event?.name }}
                  </div>
                  <div class="date-address">
                    {{ event?.getDisplayDate() }}
                  </div>
                </div>
                @if (isDesktop) {
                  @if (rsvpType === RSVPOptionType.NO) {
                    <app-event-info
                      [event]="event"
                      [showDate]="false"
                      [showDescription]="false"
                      class="event-address"
                    />
                  } @else {
                    <div class="rsvp-qr-code-actions-cont">
                      <div class="pass-actions">
                        <button
                          class="btn btn-primary"
                          (click)="seeRsvpQRCode()"
                        >
                          {{ "APP.EVENT_RSVP.SEE_YOUR_QR_CODE" | translate }}
                        </button>
                      </div>

                      <div class="add-to-wallet-actions">
                        <div class="google-wallet" (click)="addToWallet()">
                          <img src="assets/add_to_google_wallet.svg" />
                        </div>
                        <div class="apple-wallet" (click)="addToWallet()">
                          <img src="assets/add-to-apple-wallet.svg" />
                        </div>
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          </div>

          @if (!isDesktop) {
            <div class="right-content">
              <app-event-info
                [event]="event"
                [showDate]="false"
                [showDescription]="false"
                class="event-address"
              />
              <div class="cards">
                @for (card of cards; track $index) {
                  <app-generic-after-attend-section-card
                    [type]="card"
                    [rsvpType]="rsvpType"
                    [attendee]="eventAttendee"
                    [eventRsvpConfirmationPage]="eventRsvpConfirmationPage"
                    (onClose)="close()"
                  />
                }
              </div>
            </div>
          }
        </div>
        @if (isDesktop) {
          <div class="share-options">
            <app-share-buttons
              [event]="event"
              [section]="
                findSectionByType(EventRSVPConfirmationPageSectionType.MAIN)
              "
              customToastSuccessClass="toast-success-white-event-primary"
            ></app-share-buttons>
          </div>
        }
      </div>
      @if (isDesktop) {
        <div class="right-content">
          <div class="cards">
            @for (card of cards; track $index) {
              <app-generic-after-attend-section-card
                [type]="card"
                [rsvpType]="rsvpType"
                [attendee]="eventAttendee"
                [eventRsvpConfirmationPage]="eventRsvpConfirmationPage"
                (onClose)="close()"
              />
            }
          </div>
        </div>
      }
      @if (!isDesktop && eventAttendee?.isNonPendingActive()) {
        <div class="rsvp-qr-code-actions-cont-mobile">
          <div class="actions">
            <div class="pass-actions">
              <button class="btn btn-primary" (click)="seeRsvpQRCode()">
                {{ "APP.EVENT_RSVP.SEE_YOUR_QR_CODE" | translate }}
              </button>
            </div>
            <div class="share-options">
              <div class="share-button" (click)="addToCalendar()">
                <i class="far fa-calendar-day"></i>
              </div>
            </div>
          </div>
          <div class="footer-powered-by-cont">
            <span>{{ "APP.POWERED_BY" | translate }}</span>
            <app-logo-custom-fill
              class="logo"
              [fillColor]="'#B0B0B0'"
              [isGenericPage]="true"
              [height]="16"
              [isSmallLogo]="false"
            />
          </div>
        </div>
      }
    </div>
  </div>
</div>
